import React from 'react';

export interface InputLayoutProps {
    label: string,
    name: string,
    error?: string
    children: React.ReactNode
}

export default function InputLayout({label, name, error, children}: InputLayoutProps) {
    return (
        <div className="flex flex-col gap-2">
            <label htmlFor={name} className="block text-novartis-font font-semibold">
                {label}
            </label>
            {children}
            {error && <p className="text-error font-semibold ">{error}</p>}
        </div>
    );
}